var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings", {
    staticClass: "column-settings",
    attrs: {
      title: _vm.resource("TemplateColumnSettings_Settings_Title"),
      region: "right",
      tooltip: _vm.tooltip
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("settings-media-picker", {
              staticClass: "form-group",
              attrs: {
                label: _vm.resource(
                  "TemplateManager_Shared_BackgroundMediaId_Label"
                ),
                "media-id": _vm.model.style.mediaId
              },
              on: {
                "file-picked": function($event) {
                  _vm.model.style.mediaId = $event
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("settings-dropdown", {
                    attrs: {
                      options: _vm.backgroundFillOptions,
                      label: "Background size",
                      textField: "text",
                      valueField: "value"
                    },
                    model: {
                      value: _vm.model.style.backgroundSize,
                      callback: function($$v) {
                        _vm.$set(_vm.model.style, "backgroundSize", $$v)
                      },
                      expression: "model.style.backgroundSize"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.hasImage
              ? _c("settings-media-cropper", {
                  staticClass: "form-group",
                  attrs: {
                    label: _vm.resource(
                      "TemplateManager_Shared_OpenMediaCropper_Button_Text"
                    ),
                    "media-id": _vm.model.style.mediaId
                  },
                  on: {
                    "image-cropped": function($event) {
                      return _vm.imageCropped($event.mediaId, $event.crop)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("settings-color-picker", {
              attrs: {
                label: _vm.resource(
                  "TemplateManager_Shared_BackgroundColor_Label"
                )
              },
              model: {
                value: _vm.model.style.backgroundColor,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "backgroundColor", $$v)
                },
                expression: "model.style.backgroundColor"
              }
            }),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Opacity_Label"),
                "value-suffix": "%"
              },
              model: {
                value: _vm.model.style.opacity,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "opacity", $$v)
                },
                expression: "model.style.opacity"
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }